import { createContext, useState } from "react"

import axios from 'axios';
import config from '../config.json'
import { useEffect } from "react";
const GlobalSiteContext = createContext()

const GlobalSiteContextProvider = (props) => {
    
    const [challengerLeague,setChallengerLeague] = useState(null)
    const [members, setMembers] = useState(null)
    
    useEffect(() => {
        axios.get(`${config.base_url}/api/challenger-league`).then(res => {
            let data = res.data;
            let tab = [];			
            tab = data[0].entries;
            tab.sort((a, b) =>{
                if(a.leaguePoints < b.leaguePoints) {
                    return 1;
                } else {
                    return -1;
                }
            })
            data[0].entries = tab;
            data = data[0];
            setChallengerLeague(data);
        }).catch(function(error) {
            return null
        })
        axios.get(`${config.base_url}/api/aeg-members`)
		.then(res => {
			const data = res.data;
			setMembers(data)
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
      }, []);
    
    return (
        <GlobalSiteContext.Provider value={{ challengerLeague,members }}>
            { props.children }
        </GlobalSiteContext.Provider>
    )
}

export { GlobalSiteContextProvider, GlobalSiteContext }